export default function CtaSection() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[420px] md:min-h-[480px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Serene%20flatlay%20of%20shopping%20essentials%20including%20sneakers%20sunglasses%20and%20leather%20wallet%20on%20cream%20linen%20background%2C%20soft%20natural%20morning%20light%2C%20editorial%20product%20photography%2C%20warm%20minimalist%20aesthetic%2C%20no%20text%2C%20no%20branding&width=800&height=600&seq=cta-left-v2&orientation=landscape"
          alt="AllChinaBuy Spreadsheet ready to buy"
          title="Get Your AllChinaBuy Spreadsheet Now"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/15"></div>
        <div className="absolute bottom-8 left-8">
          <p className="text-3xl md:text-5xl font-extrabold text-background-50 leading-tight">
            Ready to
            <br />
            Buy?
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-8 md:px-12 py-14">
        <div className="max-w-md text-center">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
            Get Your
            <br />
            AllChinaBuy Sheet Now
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Access the most complete AllChinaBuy Spreadsheet with trusted sellers, verified products, and updated
            buying guides. Start shopping smarter and safer on AllChinaBuy today with our comprehensive
            product catalog and comparison tools.
          </p>
          <div className="mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 text-base font-bold rounded-md hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              buy it now
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
          <p className="mt-4 text-xs text-foreground-500">
            No subscription required · Free access · Updated daily
          </p>
        </div>
      </div>
    </section>
  );
}